import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  height: PropTypes.string.isRequired,
  width: PropTypes.string.isRequired,
};

const defaultProps = {
  color: '#27A9E1',
};

const Hexagon = ({ color, height, width }) => (
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    viewBox="0 0 420 220"
    style={{ enableBackground: 'new 0 0 420 200' }}
    xmlSpace="preserve"
    width={width}
    height={height}
  >
    <g>
      <g id="Layer_1_2_">
        <polygon
          id="XMLID_349_"
          fill="#F2F2F2"
          points="144.5,27.4 192.1,53.9 192.1,166.1 141.1,194.4 420,194.4 420,27.4"
        />
        <g id="XMLID_347_">
          <path
            id="XMLID_348_"
            fill={color}
            d="M96.1,0.5L0,53.9v112.3l96.1,53.4l96.1-53.4V53.9L96.1,0.5z"
          />
        </g>
        <g id="XMLID_635_">
          <path
            id="XMLID_675_"
            stroke="#FFFFFF"
            strokeMiterlimit="10"
            fill="none"
            d="M176.5,61.6L97.1,17.4L17.6,61.6"
          />
        </g>
        <g id="XMLID_637_">
          <path
            id="XMLID_677_"
            stroke="#FFFFFF"
            strokeMiterlimit="10"
            fill="none"
            d="M17.6,157.3l79.5,44.1l79.5-44.1"
          />
        </g>
      </g>
    </g>
  </svg>
);

Hexagon.propTypes = propTypes;

Hexagon.defaultProps = defaultProps;

export default Hexagon;
